import React from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt, FaEye, FaUser } from "react-icons/fa";
import ArticleThumbnail from "../../Components/Blog/ArticleThumbnail";
import { blogDetailPath } from "../../utils/seo";
import "./ArticleCard.css";

const ArticleCard = ({ id, slug, Image, Title, Author, Date, ViewCount }) => (
  <article className="home-article" dir="rtl">
    <Link className="home-article-link" to={blogDetailPath({ slug, id })}>
      <h3 dir="auto">{Title}</h3>
      <ArticleThumbnail src={Image} className="home-article-thumbnail" />
    </Link>
    <div className="home-article-meta">
      {Author && <span className="home-article-author"><FaUser aria-hidden="true" />{Author}</span>}
      {Date && <span><FaCalendarAlt aria-hidden="true" />{Date}</span>}
      {ViewCount != null && <span><FaEye aria-hidden="true" />{ViewCount.toLocaleString("fa-IR")} بازدید</span>}
    </div>
  </article>
);

export default ArticleCard;
